export function makeImagesNotDraggable(containerRef) {
  if (containerRef.current) {
    const images = containerRef.current.querySelectorAll("img");
    images.forEach((img) => {
      img.setAttribute("draggable", "false");
    });
  }
}